import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { DeactivationReasonsData } from "./types";
import { deactivationsKeys } from "./utils";

export const useDeactivationReasons = <
  TData extends {} = DeactivationReasonsData
>(
  options?: UseQueryOptions<DeactivationReasonsData, PortalAxiosError, TData>
) => {
  const server = useServer();

  return useQuery<DeactivationReasonsData, PortalAxiosError, TData>(
    deactivationsKeys.reasons,
    () => server.get("deactivation/reasons"),
    {
      staleTime: 5 * 60 * 1000,
      ...options,
    }
  );
};

export default useDeactivationReasons;
